// src/Pages/Admin/Sesion/SesionSelector.js
import React from "react";
import { Trash2 } from "lucide-react";

const badgeDe = (estado) => {
  if (estado === "completada") return { clase: "sg-badge--completada", texto: "Completada" };
  if (estado === "en_proceso" || estado === "en_roceso") {
    return { clase: "sg-badge--proceso", texto: "En proceso" };
  }
  return { clase: "sg-badge--pendiente", texto: "Pendiente" };
};

const formatearFecha = (fechaStr) => {
  if (!fechaStr) return "Sin fecha";
  try {
    return new Date(fechaStr).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return fechaStr;
  }
};

const ESTADOS = [
  { valor: "en_proceso", texto: "En proceso" },
  { valor: "completada", texto: "Completada" },
  { valor: "pendiente", texto: "Pendiente" },
];

const SesionSelector = ({
  sesiones = [],
  sesionActual,
  onSeleccionar,
  onCambiarUsuario,
  onCambiarEstado,
  usuariosCliente = [],
  onEliminar,
  guardando = false,
}) => {
  return (
    <div className="sg-panel">
      <h3 className="sg-detail-title">Sesiones ({sesiones.length})</h3>

      {sesiones.length === 0 ? (
        <div className="sg-empty">
          <p>Todavía no hay sesiones. Creá la primera para empezar a subir fotos.</p>
        </div>
      ) : (
        <div className="sg-selector">
          {sesiones.map((sesion) => {
            const activa = sesionActual?.id === sesion.id;
            const badge = badgeDe(sesion.estado);

            return (
              <div key={sesion.id} className="sg-chip-wrap">
                <button
                  type="button"
                  className={`sg-chip${activa ? " sg-chip--active" : ""}`}
                  onClick={() => onSeleccionar(sesion)}
                  aria-pressed={activa}
                >
                  <span className="sg-chip-name">
                    {sesion.nombre || `Sesión ${formatearFecha(sesion.fecha)}`}
                  </span>
                  <span className="sg-chip-meta">
                    {formatearFecha(sesion.fecha)} ·{" "}
                    {sesion.usuario_asignado?.nombre || sesion.usuario_asignado?.email || "Sin asignar"}
                  </span>
                  <span className={`sg-badge ${badge.clase}`}>{badge.texto}</span>
                </button>

                {activa && (
                  <div className="sg-chip-detail">
                    <div className="sg-chip-fields">
                      <div className="sg-field">
                        <label className="sg-label" htmlFor={`sg-asignar-${sesion.id}`}>
                          Cliente asignado
                        </label>
                        <select
                          id={`sg-asignar-${sesion.id}`}
                          className="sg-select"
                          value={sesion.usuario_id || ""}
                          onChange={(e) => onCambiarUsuario(sesion.id, e.target.value || null)}
                          disabled={guardando}
                        >
                          <option value="">Sin asignar</option>
                          {usuariosCliente.map((u) => (
                            <option key={u.id} value={u.id}>
                              {u.nombre || u.email || u.id}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="sg-field">
                        <label className="sg-label" htmlFor={`sg-estado-${sesion.id}`}>
                          Estado
                        </label>
                        <select
                          id={`sg-estado-${sesion.id}`}
                          className="sg-select"
                          value={sesion.estado || "en_proceso"}
                          onChange={(e) => onCambiarEstado(sesion.id, e.target.value)}
                          disabled={guardando}
                        >
                          {ESTADOS.map((e) => (
                            <option key={e.valor} value={e.valor}>
                              {e.texto}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {usuariosCliente.length === 0 && (
                      <p className="sg-field-error">
                        No hay clientes para asignar: el filtro de usuarios solo trae los que no
                        son Admin.
                      </p>
                    )}

                    {onEliminar && (
                      <button
                        type="button"
                        className="sg-btn sg-btn--danger-outline sg-btn--sm"
                        onClick={() => onEliminar(sesion)}
                        disabled={guardando}
                      >
                        <Trash2 size={14} /> Eliminar
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SesionSelector;